import { Injectable } from "@angular/core";
import { IID_APPARATO_SPLITTER } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDApparatoSplitterStore } from "./iidApparatoSplitter.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.APPARATO_SPLITTER)
export class IIDApparatoSplitterQuery extends AbstractInterfaceDataQuery<IID_APPARATO_SPLITTER> {

  constructor(protected store: IIDApparatoSplitterStore) {
    super(store);
  }
}
